var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 4.14144H16.1693V0.183105H3.5026V4.14144H0.335938V14.4331H3.5026V19.1831H11.0385C13.3715 19.1831 15.8114 16.3513 16.1321 14.4331H19.3359V4.14144ZM5.08594 1.76644H14.5859V4.14144H5.08594V1.76644ZM11.9663 14.9461C11.9663 14.9461 13.1293 17.5998 10.383 17.5998H5.08594V11.2664H14.5859V13.3628C14.5859 16.208 11.9663 14.9461 11.9663 14.9461ZM17.3568 6.51644C17.1383 6.51644 16.9609 6.33911 16.9609 6.12061C16.9609 5.90211 17.1383 5.72477 17.3568 5.72477C17.5753 5.72477 17.7526 5.90211 17.7526 6.12061C17.7526 6.33911 17.5753 6.51644 17.3568 6.51644ZM13.0026 13.6414H6.66927V12.8498H13.0026V13.6414ZM10.6276 14.4331H6.66927V15.2248H10.6276V14.4331Z",
    fill: "#2D94E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.a57110d28a25284b907970b1daca25d3.svg";
export { ForwardRef as ReactComponent };